// extracted by mini-css-extract-plugin
export default {"emptyFooter":"Account_emptyFooter__LUq8B"};